import React from "react";
import "./Deletepopup.css";

const DeletePopup = ({ handleDelete, setdeletepopup }) => {
  const deleteHandler = () => {
    setdeletepopup(false);
    handleDelete();
  };

  return (
    <>
      <div className="delete-blur-background" />
      <div className="popup">
        <div className="release-confirm">
          <p>
            Are you sure you want to delete? Once deleted, record can't be
            recovered.
          </p>

         <div className="popup-actions">
              <button
                className="delete-btn confirm"
                onClick={deleteHandler}
              >
                Yes
              </button>

              <button
                className="delete-btn cancel"
                onClick={() => setdeletepopup(false)}
              >
                No
              </button>
            </div>
        </div>
      </div>
    </>
  );
};

export default DeletePopup;
